"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUUID = createUUID;
exports.checkIfUserRoleMeetsRequirement = checkIfUserRoleMeetsRequirement;
exports.roleMeetsRequirement = roleMeetsRequirement;
exports.batchCheckStringParameters = batchCheckStringParameters;
const uuid_1 = require("uuid");
const constants_1 = require("../constants");
function createUUID() {
    return (0, uuid_1.v4)();
}
function checkIfUserRoleMeetsRequirement(user, userTypeRequired) {
    if (!user.emailValidated)
        return false;
    return roleMeetsRequirement(user.role, userTypeRequired);
}
function roleMeetsRequirement(role, userTypeRequired) {
    switch (role) {
        case constants_1.UserType.SYSTEM_ADMIN:
            return true;
        case constants_1.UserType.ADMIN:
            return userTypeRequired !== constants_1.UserType.SYSTEM_ADMIN;
        case constants_1.UserType.ENGINEER_ADMIN:
            return (userTypeRequired !== constants_1.UserType.SYSTEM_ADMIN &&
                userTypeRequired !== constants_1.UserType.ADMIN &&
                userTypeRequired !== constants_1.UserType.CLIENT);
        case constants_1.UserType.ENGINEER:
            return (userTypeRequired === constants_1.UserType.ENGINEER ||
                userTypeRequired === constants_1.UserType.SHIPPING);
        case constants_1.UserType.SHIPPING:
            return userTypeRequired === constants_1.UserType.SHIPPING;
        case constants_1.UserType.CLIENT:
            return userTypeRequired === constants_1.UserType.CLIENT;
        default:
            return false;
    }
}
function batchCheckStringParameters(params) {
    for (const param of params) {
        if (param === null ||
            param === undefined ||
            param === "" ||
            param.trim() === "") {
            return false;
        }
    }
    return true;
}
